<script lang="ts">
  import Button from 'Catalyst/components/Button/Button.svelte';
  import Header from 'Components/SessionV2/Header.svelte';
  import IconButton from 'Catalyst/components/IconButton/IconButton.svelte';
  import SocialLogin from 'Components/SessionV2/SocialLogin.svelte';
  import Switcher from 'Components/SessionV2/Switcher.svelte';
  import TextInput from 'Catalyst/components/TextInput/TextInput.svelte';

  export let emailAuthPath: string;
  export let authenticityToken: string;
  export let forgotPasswordPath: string;
  export let companyPrimaryColor: string;
  export let alert: string;
  export let googleAuthPath: string;
  export let appleAuthPath: string;
  export let facebookAuthPath: string;
  export let showSignUpOption: boolean;
  export let toggleSignUp: () => void;

  let formElement: HTMLFormElement;

  let isSubmitting = false;

  let revealPassword = false;
  let showPasswordInput = false;

  let email: string;
  let password: string;

  const onSubmit = (): void => {
    isSubmitting = true;
  };
</script>

<Header text="Sign in to your account" />

<div class="flex flex-column gap-[1rem]">
  <SocialLogin {googleAuthPath} {appleAuthPath} {facebookAuthPath} />
</div>

<span class="text-[#344054] text-lg/[1.25rem] font-medium text-center">OR</span>
<form
  data-testid="sign-in-form"
  bind:this={formElement}
  class="w-full flex flex-col mb-0 gap-[1.5rem]"
  action={emailAuthPath}
  method="post"
  on:submit={onSubmit}
>
  <input
    type="hidden"
    name="authenticity_token"
    value={authenticityToken}
    data-testid="authenticity-token-input"
  />

  <div>
    <div class="flex flex-col gap-[1rem]">
      <TextInput
        bind:value={email}
        id="email"
        name="user[email]"
        label="Email"
        invalid={!!alert}
        on:focus={() => {
          showPasswordInput = true;
          alert = null;
        }}
      />

      {#if showPasswordInput}
        <TextInput
          bind:value={password}
          id="password"
          name="user[password]"
          type={!revealPassword ? 'password' : 'text'}
          label="Password"
          invalid={!!alert}
          autocomplete="off"
        >
          <IconButton
            data-testid="password-visibility-button"
            iconFilled={revealPassword}
            slot="suffix"
            icon={revealPassword ? 'visibility' : 'visibility_off'}
            class="mr-[0.375rem] w-[1.75rem] h-[1.75rem] focus-visible:shadow-none focus-visible:bg-[--icon-button-variants-style-standard-surface-hover]"
            on:click={() => {
              revealPassword = !revealPassword;
              alert = null;
            }}
          />
        </TextInput>
      {/if}
    </div>
    {#if alert}
      <p
        class="text-xs text-[#CF484C] font-normal mt-[0.25rem]"
        data-testid="alert-message"
      >
        {alert}
      </p>
    {/if}
  </div>

  <Button
    data-testid="submit-button"
    type="submit"
    size="lg"
    disabled={!email || !password || isSubmitting}
  >
    Continue
  </Button>

  <a
    data-testid="forgot-password-link"
    href={forgotPasswordPath}
    class="font-medium text-center text-sm hover:underline hover:cursor-pointer"
    style={`color: ${companyPrimaryColor || '#2E9990'}`}
  >
    Forgot password?
  </a>
</form>

{#if showSignUpOption}
  <Switcher
    {companyPrimaryColor}
    text="Don’t have an account and"
    buttonText="want to sign up instead?"
    toggleCardState={toggleSignUp}
  />
{/if}
